module.exports = __webpack_public_path__ + "assets/img/files.829b4437.svg";